module.exports = __webpack_public_path__ + "img/DE05732.65bd6206.png";